var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgDef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 829,
    viewBox: "0 0 1728 829",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2992_10995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1728V828.893H0V0Z",
    fill: "url(#paint0_linear_2992_10995)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1478,
    height: 833,
    fill: "url(#paint1_linear_2992_10995)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter0_f_2992_10995)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1584.5,
    cy: 653.893,
    rx: 374.5,
    ry: 374,
    fill: "#33C2B0"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_2992_10995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1551.5,
    cy: 213.393,
    r: 367.5,
    fill: "url(#paint2_linear_2992_10995)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2992_10995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 580.893,
    r: 395,
    fill: "url(#paint3_linear_2992_10995)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2992_10995",
    x: 860,
    y: -70.1074,
    width: 1449,
    height: 1448,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_2992_10995"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2992_10995",
    x: 834,
    y: -504.107,
    width: 1435,
    height: 1435,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_2992_10995"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2992_10995",
    x: -541,
    y: -164.107,
    width: 1490,
    height: 1490,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_2992_10995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2992_10995",
    x1: -0.0000225711,
    y1: 471.04,
    x2: 1728,
    y2: 471.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C353D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C353D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2992_10995",
    x1: 446.5,
    y1: 416,
    x2: 1290.5,
    y2: 416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191B23",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191B23",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2992_10995",
    x1: 1766.49,
    y1: -31.6074,
    x2: 1551.5,
    y2: 580.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2992_10995",
    x1: 435.075,
    y1: 317.559,
    x2: 204,
    y2: 975.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F5CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2992_10995"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1728V828.893H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDef);
export default __webpack_public_path__ + "static/media/bg-def.88fee6990d53df2cfe3846775e6313c0.svg";
export { ForwardRef as ReactComponent };